module.exports = __webpack_public_path__ + "img/waiting.d90ffd64.png";